<template>
  <b-container>
    <!--Período -->
    <b-row>
      <b-col cols="6">
        <b-form-group
          :label="$t('fuelConsumptionTarget.fields.beginAt')"
          label-for="beginAt"
        >
          <b-form-input
            id="beginAt"
            type="date"
            :placeholder="$t('fuelConsumptionTarget.fields.beginAt')"
            v-model="model.beginAt"
          />
        </b-form-group>
      </b-col>
      <!-- <b-col>
        <b-form-group
          :label="$t('fuelConsumptionTarget.fields.endAt')"
          label-for="endAt"
        >
          <b-form-input
            id="endAt"
            type="date"
            :placeholder="$t('fuelConsumptionTarget.fields.endAt')"
            v-model="model.endAt"
          /> </b-form-group
      ></b-col> -->
    </b-row>
    <b-row>
      <span class="text-danger" v-if="modelstate['BeginAt']">
        {{ modelstate["BeginAt"][0] }}
      </span>
      <span class="text-danger" v-if="modelstate['EndAt']">
        {{ modelstate["EndAt"][0] }}
      </span>
    </b-row>

    <!-- Peso -->
    <b-row>
      <b-col>
        <b-form-group
          :label="$t('fuelConsumptionTarget.fields.weightBegin')"
          label-for="weightBegin"
        >
          <decimal-input-masked
            v-model="model.weightBegin"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          :label="$t('fuelConsumptionTarget.fields.weightEnd')"
          label-for="weightEnd"
        >
          <decimal-input-masked
            v-model="model.weightEnd"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <span class="text-danger" v-if="modelstate['WeightBegin']">
        {{ modelstate["WeightBegin"][0] }}
      </span>
      <span class="text-danger" v-if="modelstate['WeightEnd']">
        {{ modelstate["WeightEnd"][0] }}
      </span>
    </b-row>

    <b-row>
      <b-col>
        <!-- tipo do marcarodor km/l - hora/l -->
        <b-form-group
          :label="$t('fuelConsumptionTarget.fields.typeConsumptionTarget')"
          label-for="consumptionTarget"
        >
          <b-form-select v-model="model.markerType" :options="markerTypeOpt">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <!-- meta de consumo -->
        <b-form-group
          :label="$t('fuelConsumptionTarget.fields.consumptionTarget')"
          label-for="consumptionTarget"
        >
          <decimal-input-masked
            v-model="model.consumptionTarget"
          />
          <span class="text-danger" v-if="modelstate['ConsumptionTarget']">
            {{ modelstate["ConsumptionTarget"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Modelo que será aplicada a meta -->
    <b-form-group
      :label="$t('fuelConsumptionTarget.fields.vehicleModel')"
      label-for="vehicleModelId"
    >
      <VehicleModelDropdown
        id="vehicleModelId"
        :vehicleModelId.sync="model.vehicleModelId"
      />
      <span class="text-danger" v-if="modelstate['VehicleModelId']">
        {{ modelstate["VehicleModelId"][0] }}
      </span>
    </b-form-group>
    <!-- Veículo que será aplicada a meta -->
    <b-form-group
      :label="$t('fuelConsumptionTarget.fields.vehicle')"
      label-for="vehicleId"
    >
      <VehicleDropdown
        id="vehicleId"
        :vehicleId.sync="model.vehicleId"
        :markerType="model.markerType"
      />
      <span class="text-danger" v-if="modelstate['VehicleId']">
        {{ modelstate["VehicleId"][0] }}
      </span>
    </b-form-group>

    <!-- Checklist de destino da meta -->
    <b-form-group
      :label="$t('fuelConsumptionTarget.fields.fuelSupplyChecklistId')"
      label-for="fuelSupplyChecklistId"
    >
      <b-form-input
        type="text"
        :id="$t('fuelConsumptionTarget.fields.fuelSupplyChecklistId')"
        :placeholder="$t('fuelConsumptionTarget.fields.fuelSupplyChecklistId')"
        v-model="model.fuelSupplyChecklistId"
        v-integer-mask
      />
      <span class="text-danger" v-if="modelstate['FuelSupplyChecklistId']">
        {{ modelstate["FuelSupplyChecklistId"][0] }}
      </span>
    </b-form-group>
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";
import DecimalInputMasked from "@/components_rms/base/DecimalInputMasked.vue";

export default {
  name: "FuelConsumptionTargetCrud",
  props: {
    model: {
      type: Object,
      description: "Meta de abastecimento",
      default() {
        return {
          vehicleModelId: "",
          vehicleId: null,
          beginAt: null,
          endAt: null,
          weightBegin: "0,00",
          weightEnd: "0,00",
          consumptionTarget: "0,00",
          originChecklistId: "",
          fuelSupplyChecklistId: "",
          fuelSupplyId: "",
          markerType: null,
        };
      },
    },
    modelstate: {
      type: Object,
      description: "Estado do salvamento",
      default() {
        return {};
      },
    },
  },
  directives: {
    mask: AwesomeMask,
  },
  components: {
    DecimalInputMasked,
    VehicleDropdown: () =>
      import("@/components_rms/vehicle/Registration/VehicleDropdown.vue"),
    VehicleModelDropdown: () =>
      import("@/components_rms/System/VehicleModel/VehicleModelDropdown.vue"),
  },
  created() {
    this.getAllVehicleType();
    // this.dataFormat();
  },
  data() {
    return {
      vehicleTypeOpt: [],
      vehicleModelId: 0,
      markerTypeOpt: [
        { value: null, text: "Selecione um marcador" },
        { value: 0, text: "Hodômetro" },
        { value: 1, text: "Horimetro" },
      ],
    };
  },
  methods: {
    getAllVehicleType() {
      this.$apiVehicle.get("/vehicleType/getDropdown/").then((response) => {
        this.vehicleTypeOpt = response.data;
      });
    },
    convertToString() {
      this.model.vehicleModelId = this.vehicleModelId.toString();
    },
  },
};
</script>